import { render, staticRenderFns } from "./Cube.vue?vue&type=template&id=4df8cd4f&scoped=true&"
import script from "./Cube.vue?vue&type=script&lang=js&"
export * from "./Cube.vue?vue&type=script&lang=js&"
import style0 from "./Cube.vue?vue&type=style&index=0&id=4df8cd4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df8cd4f",
  null
  
)

export default component.exports